export function mergeArrays(arr1 = [], arr2  = []) {

    let a1 = JSON.parse(JSON.stringify(arr1));
    let a2 = JSON.parse(JSON.stringify(arr2));

    const merged = [];

    const map = new Map();

    // Helper function to merge objects
    function mergeObjects(obj1, obj2) {
        const obj = {
            ...obj1
        }
        if(obj.hasOwnProperty('PossibleValues') && Array.isArray(obj1.PossibleValues) && obj1.PossibleValues?.length) {
            const pv = obj.PossibleValues;
            const pv1 = JSON.stringify(obj1?.PossibleValues);

            obj2?.PossibleValues?.forEach((p) => {
                if(!pv1.includes(JSON.stringify(p))) pv.push(p)
            })

            obj.PossibleValues = pv
        } 
        if(obj.hasOwnProperty('Default')) obj.Default = [Math.min(...obj1.Default, ...obj2.Default), Math.max(...obj1.Default, ...obj2.Default)]
        
        if(obj1.hasOwnProperty('MaxValue') || obj2.hasOwnProperty('MinValue')) {
            obj.MaxValue = Math.max(obj1.MaxValue, obj2.MaxValue)
            obj.MinValue = Math.min(obj1.MinValue, obj2.MinValue)
        }

        return {
            ...obj
        };
    }

    // Process the first array
    a1.forEach(obj => {
        map.set(obj.Label, { ...obj });
    });
   
    // Process the second array
    a2.forEach(obj => {
        if (map.has(obj.Label)) {
            const existingObj = map.get(obj.Label);
            map.set(obj.Label, mergeObjects(existingObj, obj));
        } else {
            merged.push({...obj});
        }
    });
    
    // Convert map back to an array
    map.forEach(value => {
        merged.push(value);
    });

    
    arr1 = arr1.filter((arr) => arr.Label !== "Type")
    arr2 = arr2.filter((arr) => arr.Label !== "Type")

    return [merged, arr1, arr2];
}


const shouldMultipropertyCheck = false;

export function mergeGallary(
  galleryComponent = {},
  projectIds = [],
  pid,
  pin
) {
  if (!galleryComponent || galleryComponent.TypeName !== "Gallery") {
    console.error("Invalid component data");
    return;
  }

  if (!Array.isArray(projectIds) || projectIds.length === 0) {
    console.error("Invalid projectIds array");
    return;
  }

  if (!pid) {
    return { 0: galleryComponent, 1: {}, 2: {} };
  }

  // Allowed E_IDs from backend
  const projectIdSet = new Set(
    String(projectIds[0])
      .split(',')
      .map(v => v.trim())
  );

  // Selected E_IDs (pid)
  const pidSet = new Set(
    String(pid)
      .split(',')
      .map(v => v.trim())
      .filter(v => projectIdSet.has(v)) // 🔒 safety
  );

  // Clone original gallery safely
  const originalGallery = structuredClone(galleryComponent);
  originalGallery.Data.ListOfPhotos = [];
  originalGallery.Data.NoOfPhotos = 0;
  originalGallery.Tags = [];

  const groupedPhotos = {
    0: originalGallery,
    1: {
      TypeID: galleryComponent.TypeID,
      TypeName: galleryComponent.TypeName,
      Data: { NoOfPhotos: 0, ListOfPhotos: [] },
      Tags: []
    },
    2: {
      TypeID: galleryComponent.TypeID,
      TypeName: galleryComponent.TypeName,
      Data: { NoOfPhotos: 0, ListOfPhotos: [] },
      Tags: []
    }
  };

  const ListOfPhotos = Array.isArray(galleryComponent?.Data?.ListOfPhotos)
    ? galleryComponent.Data.ListOfPhotos.filter(Boolean)
    : [];

  // Group photos by E_ID
  const photosByEid = {};

  ListOfPhotos.forEach(photo => {
    const eid = String(photo.E_ID);
    if (!projectIdSet.has(eid)) return;

    if (!photosByEid[eid]) photosByEid[eid] = [];
    photosByEid[eid].push(photo);
  });

  // 🔑 Decide mode
  const isAllPropertiesSelected =
    pidSet.size === projectIdSet.size &&
    [...pidSet].every(id => projectIdSet.has(id));

  // SINGLE GALLERY MODE
  if (!shouldMultipropertyCheck || pidSet.size === 1 || isAllPropertiesSelected) {

    pidSet.forEach(eid => {
      (photosByEid[eid] || []).forEach(photo => {
        groupedPhotos[0].Data.ListOfPhotos.push(photo);
        groupedPhotos[0].Data.NoOfPhotos++;

        const tag = photo.Tags?.[0];
        if (tag && !groupedPhotos[0].Tags.includes(tag)) {
          groupedPhotos[0].Tags.push(tag);
        }
      });
    });

    return groupedPhotos;
  }

  // MULTIPROPERTY MODE → max 2 properties
  const orderedEids = [...projectIdSet].filter(eid => pidSet.has(eid));

  orderedEids.slice(0, 2).forEach((eid, index) => {
    const key = index + 1;

    (photosByEid[eid] || []).forEach(photo => {
      groupedPhotos[key].Data.ListOfPhotos.push(photo);
      groupedPhotos[key].Data.NoOfPhotos++;

      const tag = photo.Tags?.[0];
      if (tag && !groupedPhotos[key].Tags.includes(tag)) {
        groupedPhotos[key].Tags.push(tag);
      }
    });
  });

  return groupedPhotos;
}



export function filterInc(units = [], filter) {
  let newF = filter.map(option => ({ ...option }));

  const unitT = {
    rent: false,
    sales: false
  }

  for(let i=0; i<units.length; i++) {
    const unit = units[i]

    if(unit?.Data?.SalesTypeEjerlejlighed?.Value) {
      unitT.sales = true
    }else if(unit?.Data?.SalesTypeLejelejlighed?.Value) {
      unitT.rent = true
    }

    if(unitT.sales && unitT.rent) {
      newF.unshift({
        "Default": [
            101,
            103
        ],
        "Type": "MultiSelect",
        "Label": "Type",
        "Postfix": "",
        "PossibleValues": [
            {
                "ID": 101,
                "Value": "Salg",
                "ValueProperty": "SalesTypeEjerlejlighed"
            },
            {
                "ID": 103,
                "ValueProperty": "SalesTypeLejelejlighed",
                "Value": "Leje"
            }
        ]
      })
      break;
    };
  }

  if(unitT.sales && !unitT.rent) {
    const newD = getData(newF, "Status")

    if(Object.keys(newD).length) {
      newF[newD.index].PossibleValues = newF[newD.index]?.PossibleValues?.filter((pv) => {
        if(pv.ID === 30) return false
        return true
      })
    }
  }else if(!unitT.sales && unitT.rent) {
    const newD = getData(newF, "Status")

    if(Object.keys(newD).length) {
      newF[newD.index].PossibleValues = newF[newD.index]?.PossibleValues?.filter((pv) => {
        if(pv.ID === 40) return false
        return true
      })
    }
  }
  
  // console.log(unitT,newF,'unit')
  return newF
}

// get filter data by label
const getData = (array, label) => {
  
  for(let i=0; i<array.length; i++) {
    const obj = array[i]

    if(obj.Label === label) {
      return {
        index: i,
        data: obj
      }
      break;
    }
  }

  return {}
}